import { finalize, tap } from 'rxjs/operators';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Session } from '../entity/entities';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  count = 0;
  ignoreList = [
    'PDAPGlobalConfiguration/getGlobalConfiguration'
  ];

  constructor(private spinner: NgxSpinnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Insights V2 cards (#27147) own their per-card loading state, so the global
    // spinner would double up with the in-card spinner. Bypass the count/show
    // bookkeeping for any /api/Insights/* endpoint.
    // G2 in-app review calls (#28067) run in the background (prefetch on popup open,
    // fire-and-forget events) — never block the whole app with the global spinner.
    // The Schedule Builder polls the solver job (#29451) and shows its own progress
    // pill; a global spinner flashing every few seconds would look like a fault.
    // Notifications poll (#29587) runs in the background too — same treatment.
    // Payroll template Validate/DryRun (#29659) take 10–30 s and show their own running
    // state with elapsed time on the template page.
    const skipSpinner =
      req.url.indexOf('/api/Insights/') !== -1 ||
      req.url.indexOf('reviews/g2') !== -1 ||
      req.url.indexOf('UserTicket/GetSupportBadgeCount') !== -1 ||
      req.url.indexOf('TLMSchedule/GetLatestJob') !== -1 ||
      req.url.indexOf('GratNotifications/GetNotificationsForUser') !== -1 ||
      req.url.indexOf('PDAPPayrollExportTemplateConfig/Validate') !== -1 ||
      req.url.indexOf('PDAPPayrollExportTemplateConfig/DryRun') !== -1;

    if (!skipSpinner) {
      this.count++;
      //STRANGE< BUT IT WORKS LIKE THIS WITH SETTIMEOUT ON SUBSEQUENT CALLS. ONLY this.spinner.show() WONT WORK IF hide() IS CALLED PREVIOUSLY
        setTimeout(() => {
          /** spinner ends after API response */
          if (this.count > 0)
            Session.showSpinner = true && !Session.suppressSpinner;
          //this.spinner.show();
        }, 0);
    }
    return next
      .handle(req)
      .pipe(
        tap(
          // No need to wrote every successful call in browser console for all environments,
          // uncomment if required for local development only!
          (event) => { /*console.log(event)*/ },
          (error) => { console.log(error) }
        ),
        finalize(() => {
          if (!skipSpinner) {
            this.count--;
            if (this.count == 0) Session.showSpinner = false;
            //this.spinner.hide();
          }
        })
      );
  }
}
